//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

// polyfill for IE 10, 9 and probably 8
import { StyledEngineProvider, ThemeProvider, adaptV4Theme, createTheme } from "@mui/material/styles";
import "core-js/stable/array";
import "core-js/stable/map";
import "core-js/stable/object";
import "core-js/stable/promise";
import "core-js/stable/set";
import * as history from "history";
import { MATERIAL_UI_THEME } from "myriota-common/constant";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Route, Router } from "react-router";
import "regenerator-runtime/runtime";
import AppContainer from "src/app/AppComponent";

const browserHistory: history.History = history.createBrowserHistory({
    basename: "v1/docs"
});

const muiTheme = createTheme(adaptV4Theme(MATERIAL_UI_THEME as any));

ReactDOM.render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>
            <Router history={browserHistory}>
                <Route path="/" component={AppContainer} />
            </Router>
        </ThemeProvider>
    </StyledEngineProvider>, document.getElementById("app")
);
